import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import companyInfoLogo from "../../assets/companyInfoLogo.png"
import bannerImage from '../../assets/bannerImage01.jpeg';
import logo from '../../assets/logo.png';
// import background from '../../assets/companyInfoBg.png';
import styles from './CompanyInfo.module.scss';
function CompanyInfo() {
  return (
    <div>
      <Header />
      <div className={styles.contentWrap}>
        <p>
          슬림알엑스는
          <br />
          <span className={styles.themeColor}>
            비대면 한방 진료의 새로운 <br /> 서비스를 제공
          </span>
          <span className={styles.inlineText}>합니다!</span>
        </p>
        <p>
          슬림알엑스는 병원 방문 없이 간편하게
          <br />
          한방 진료를 받을 수 있는 서비스로,
          <br />
          빠르고 안전한 의료 서비스를 제공합니다.
        </p>
        <img src={companyInfoLogo} alt="Company Info Logo" />
      </div>
      <Footer />
    </div>
  );
}

export default CompanyInfo;
